// This is the replacement for `src/rxdb/rxdbCollectionName.ts`
export enum RxdbCollectionNameV2 {
  ASSIGNMENT = 'assignment',
  ASSIGNMENT_EMPLOYEE = 'assignment_employee',
  ASSIGNMENT_ROLE = 'assignment_role',
  BLOCKS = 'blocks',
  BORER_ACTIVITY = 'borer_activity',
  BORER_ACTIVITY_TYPE = 'borer_activity_type',
  BORER_DOCUMENT_UPLOAD = 'borer_document_upload',
  BORER_OPERATOR_CHANGE_FEED = 'borer_operator_change_feed',
  BORER_OPERATOR_STATE_FEED = 'borer_operator_state_feed',
  BORER_SHIFT = 'borer_shift',
  BORER_SHIFT_ACTIVITY_EMPLOYEES = 'borer_shift_activity_employees',
  BORER_SHIFT_ADVANCE = 'borer_shift_advance',
  BORER_SHIFT_COMMENT = 'borer_shift_comment',
  BORER_SHIFT_COMMENT_TYPE = 'borer_shift_comment_type',
  BORER_SHIFT_CREW = 'borer_shift_crew',
  BORER_SHIFT_CREW_MEMBER = 'borer_shift_crew_member',
  BORER_SHIFT_CREW_MEMBER_ROLE = 'borer_shift_crew_member_role',
  BORER_SHIFT_INFO = 'borer_shift_info',
  BORER_SHIFT_PREDICTION = 'borer_shift_prediction',
  BORER_SHIFT_PRODUCTION = 'borer_shift_production',
  BORER_SHIFT_SIGNATURE = 'borer_shift_signature',
  BORER_SHIFT_TARGET = 'borer_shift_target',
  BORER_STATE_TYPE = 'borer_state_type',
  BORER_STATE_TYPE_CATEGORY = 'borer_state_type_category',
  CREWS = 'crews',
  CUTTING_METHOD = 'cutting_method',
  CUTTING_PERMIT_SUPERVISOR_COMMENT = 'cutting_permit_supervisor_comment',
  CUTTING_TYPE = 'cutting_type',
  DAILY_SAFETY_TOPIC = 'daily_safety_topic',
  DELAY_ACTIVITY_TYPE_CATEGORY = 'delay_activity_type_category',
  DEPARTMENT = 'department',
  DOCUMENT_TYPES = 'document_types',
  DOCUMENT_UPLOAD = 'document_upload',
  EMPLOYEES = 'employees',
  EQUIPMENT = 'equipment',
  EQUIPMENT_DEFICIENCY = 'equipment_deficiency',
  EQUIPMENT_DEFICIENCY_ATTACHMENT = 'equipment_deficiency_attachment',
  EQUIPMENT_DEFICIENCY_LOG = 'equipment_deficiency_log',
  EQUIPMENT_STATUS = 'equipment_status',
  EQUIPMENT_TYPE = 'equipment_type',
  GROUND_CONTROL_SETS = 'ground_control_sets',
  GROUND_CONTROL_TYPES = 'ground_control_types',
  GROUND_HAZARD_CONDITION_TYPES = 'ground_hazard_condition_types',
  GROUND_HAZARDS = 'ground_hazards',
  GROUND_HAZARDS_ATTACHMENTS = 'ground_hazard_attachments',
  HAZARD_LOGS = 'hazard_logs',
  HAZARD_SEVERITIES = 'hazard_severities',
  INSPECTION_CATEGORIES = 'inspection_categories',
  INSPECTION_OPTIONS = 'inspection_options',
  INSPECTION_RESULTS = 'inspection_results',
  INSPECTION_SEVERITY = 'inspection_severity',
  INSPECTIONS = 'inspections',
  LOCATIONS = 'locations',
  MINING_CUTS = 'mining_cuts',
  MINING_PATTERN = 'mining_pattern',
  PANEL_DRAWING_COMMENTS = 'panel_drawing_comments',
  PANEL_DRAWINGS = 'panel_drawings',
  PANEL_LOGS = 'panel_logs',
  PANELS = 'panels',
  PASSES = 'passes',
  POSITIONS = 'positions',
  ROOMS = 'rooms',
  SEQUENCES = 'sequences',
  SERVICE_STATUS = 'service_status',
  SHIFT = 'shift',
  SIGNATURES = 'signatures',
  SITES = 'sites',
  SUPPLIES = 'supplies',
  SUPPLY_ITEMS = 'supply_items',
  SURVEY_POINTS = 'survey_points',
  TARGET_BORER_RUNNING_TIMES = 'target_borer_running_times',
  WORK_ORDERS = 'work_orders',
}
